import { render } from "./Input.vue?vue&type=template&id=073ca2da"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"
script.render = render

export default script